export default {
    dropdown: '0 2px 8px 0 rgba(0, 0, 0, 0.15)',
    page: '0 -2px 5px 0 rgba(0, 0, 0, 0.1)',
    alertSuccess: '0 2px 8px 0 rgba(174, 224, 198, 0.7)',
    alertFailure: '0 2px 8px 0 rgba(210, 126, 126, 0.4)',
};
